import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dropdown, Badge, MenuProps } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import settings from 'popups/Settings'

import classNames from 'classnames'
import { AvatarImg } from 'pages/main/data/def'

import styles from './style.module.scss'

interface User {
  id: string
  name: string
  email: string
  avatar: string
  workspace?: any
}

// interface AppSettings {
//   isOfficenextMessenger: boolean
// }

const mapStateToProps = ({ user, appsettings, dispatch }: any) => ({
  user: user as User,
  isOfficenextMessenger: appsettings.isOfficenextMessenger as boolean,
  dispatch,
})

interface DropdownMenuProps {
  user: User
  dispatch: any
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ dispatch, user }) => {
  const { t } = useTranslation()
  const [count, setCount] = useState(0)

  // const chatUI = new ChatUI(this)

  const logout = (e: React.MouseEvent) => {
    e.preventDefault()
    dispatch({
      type: 'user/LOGOUT',
    })
  }

  const addCount = () => {
    // setCount(count + 1)
    // count가 0이면 badge가 표시안됨.
    setCount(0)
  }

  const openSettings = () => {
    // chatUI.openProfileSettings(user.id, user.avatar, user.name, user.email, () => {
    //   dispatch({
    //     type: 'user/LOAD_CURRENT_ACCOUNT',
    //   })
    // })
  }

  const onMenuClick = (e: any) => {
    const { key } = e
    if (key === 'settings') {
      console.log(' -- onMenuClick : ', key)
      openSettings()
    }
  }

  // const role = user != null && user.workspace != null ? user.workspace.role : ''
  // const email = user != null ? user.email : ''

  // const userMember = {
  //   display_name: user.name,
  //   avatar_url: user.avatar,
  //   type: role,
  //   email,
  // }

  // const extraElem = (
  //   <React.Fragment>
  //     <Button
  //       type="primary"
  //       size="large"
  //       onClick={() => {
  //         openSettings()
  //       }}
  //     >
  //       {t('topBar.profileMenu.settings')}
  //     </Button>
  //   </React.Fragment>
  // )

  const items: MenuProps['items'] = [
    {
      label: <div>{t('common.button.settings')}</div>,
      key: 'settings',
      onClick: () => {
        settings.open({})
      },
    },
    {
      type: 'divider',
    },
    {
      label: (
        <a href="#" onClick={logout}>
          {t('topBar.profileMenu.logout')}
        </a>
      ),
      key: 'logout',
    },
  ]

  // const menu = <Menu selectable={false} items={items} />
  const menu: MenuProps = {
    items,
    selectable: false,
    onClick: onMenuClick,
  }

  // let avatarElem = null
  // if (user == null) {
  // avatarElem = <UserOutlined />
  // } else {
  //   avatarElem = getInitialAvatar(user.name, user.email)
  // }

  const clsProps = {
    menu,
    trigger: ['click'] as any,
    onOpenChange: addCount,
    overlayClassName: classNames(styles.userMenu, 'floatingSubMenu', 'menuStyle1', 'contextMenu'),
  }

  const avatarElem =
    user.email != null && user.email.length > 0 ? (
      <AvatarImg
        clsName={styles.avatar}
        name={settings.getValue('account').accountName as any}
        email={user.email}
        defaultSrc={user.avatar}
        skipLogo
      />
    ) : (
      <span className={styles.avatar}>
        <UserOutlined />
      </span>
    )

  return (
    <Dropdown {...clsProps}>
      <div className={styles.dropdown}>
        <Badge count={count}>
          {avatarElem}
          {/*
          <Avatar
            src={user.avatar}
            className={styles.avatar}
            shape="circle"
            size={32}
            icon={avatarElem}
          />
          */}
        </Badge>
      </div>
    </Dropdown>
  )
}

interface UserProfileProps {
  user: User
}

const UserProfile: React.FC<UserProfileProps> = ({ user }) => {
  const avatarElem =
    user.email != null && user.email.length > 0 ? (
      <AvatarImg
        clsName={styles.avatar}
        name={settings.getValue('account').accountName as any}
        email={user.email}
        defaultSrc={user.avatar}
        skipLogo
      />
    ) : (
      <span className={styles.avatar}>
        <UserOutlined />
      </span>
    )

  return <div className={styles.userProfile}>{avatarElem}</div>
}

interface ProfileMenuProps {
  user: User
  isOfficenextMessenger: boolean
  dispatch: any
}

const ProfileMenu: React.FC<ProfileMenuProps> = ({ dispatch, user, isOfficenextMessenger }) => {
  if (isOfficenextMessenger === true) {
    return <UserProfile user={user} />
  }

  return <DropdownMenu dispatch={dispatch} user={user} />
}

export default connect(mapStateToProps)(ProfileMenu)
